export const landingLinks = {
  telegram: 'https://t.me/hedgerbar',
  twitter: 'https://x.com/Hedger_bar',
  guide: 'https://hedger.bar/guide/opisanie/o-platforme'
};

export const landingCopy = {
  ru: {
    nav: {
      product: 'Продукт',
      flow: 'Запуск',
      security: 'Безопасность',
      guide: 'Гайд',
      login: 'Войти',
      launch: 'Перейти',
      dashboard: 'Перейти'
    },
    hero: {
      eyebrow: 'Hedger',
      title: 'Платформа для алгоритмической торговли',
      subtitle: ['Настраивайте стратегии, проверяйте их на исторических данных и запускайте автоматическую торговлю без лишней сложности.'],
      primary: 'Начать работу',
      secondary: 'Открыть документацию',
      tertiary: 'Войти',
      points: ['Настройка стратегий', 'Исторический бэктест', 'Авто-торговля'],
      socialLabel: 'Ссылки'
    },
    product: {
      eyebrow: 'Платформа',
      title: 'Всё для работы со стратегией в одном месте',
      subtitle:
        'Настройте параметры стратегии, проверьте её на исторических данных и запустите автоматическую торговлю — прямо из интерфейса Hedger.',
      cards: [
        {
          key: 'setup',
          title: 'Настройка стратегии',
          text: 'Задайте параметры стратегии: таймфрейм, объём позиции, плечо и логику исполнения ордеров. Все основные настройки собраны в одном интерфейсе.'
        },
        {
          key: 'backtest',
          title: 'Проверка на исторических данных',
          text: 'Перед запуском можно проверить, как стратегия работала бы на прошлых рыночных данных и как выбранные параметры влияют на результат.'
        },
        {
          key: 'auto',
          title: 'Запуск авто-торговли',
          text: 'После настройки и проверки стратегия переводится в рабочий режим и начинает торговать автоматически.'
        }
      ]
    },
    flow: {
      eyebrow: 'Запуск',
      title: 'Как начать работу?',
      subtitle: 'Подключите биржу, настройте стратегию и запустите автоматическую торговлю.',
      steps: [
        {
          index: '01',
          title: 'Подключить биржу',
          text: 'Добавьте API-ключ вашей биржи, чтобы платформа могла работать с вашим торговым аккаунтом.'
        },
        {
          index: '02',
          title: 'Настроить стратегию',
          text: 'Задайте параметры стратегии и проверьте её результат на исторических данных.'
        },
        {
          index: '03',
          title: 'Запустить автоторговлю',
          text: 'После настройки стратегия запускается в автоматическом режиме, а её работу можно контролировать через интерфейс.'
        }
      ]
    },
    security: {
      eyebrow: 'Безопасность',
      title: 'Контроль и доступ остаются прозрачными.',
      text:
        'Средства остаются на стороне биржи, а подключение выполняется по API с торговыми разрешениями. Управление стратегиями и контроль статуса происходят через Hedger.',
      bullets: [
        'Платформа не принимает депозиты пользователей.',
        'API-доступ ограничивается торговыми действиями.',
        'Подробный гайд сопровождает подключение и первый запуск.'
      ],
      partnerLabel: 'Официальный партнер',
      partnerText: 'Bybit'
    },
    resources: {
      eyebrow: 'Ресурсы',
      title: 'Документация и ресурсы',
      items: [
        {
          key: 'guide',
          title: 'Гайд',
          text: 'Пошаговые инструкции по настройке платформы, подключению биржи и запуску стратегии.'
        },
        {
          key: 'telegram',
          title: 'Telegram',
          text: 'Основной канал Hedger для новостей, обновлений и общения с сообществом.'
        },
        {
          key: 'twitter',
          title: 'X / Twitter',
          text: 'Публичные обновления о развитии продукта и новых возможностях платформы.'
        }
      ]
    },
    cta: {
      title: 'Настройте стратегию и запустите автоматическую торговлю',
      text: 'Создайте стратегию, проверьте её на исторических данных и запустите торговлю через платформу Hedger.',
      primary: 'Начать работу',
      secondary: 'Читать гайд'
    },
    footer: {
      copy: '© 2025 Hedger'
    }
  },
  en: {
    nav: {
      product: 'Product',
      flow: 'Launch',
      security: 'Security',
      guide: 'Guide',
      login: 'Sign in',
      launch: 'Go',
      dashboard: 'Go'
    },
    hero: {
      eyebrow: 'Hedger',
      title: 'Platform for algorithmic trading',
      subtitle: ['Configure strategies, validate them on historical data and launch automated trading without unnecessary complexity.'],
      primary: 'Get started',
      secondary: 'Open documentation',
      tertiary: 'Sign in',
      points: ['Strategy setup', 'Historical backtests', 'Auto-trading'],
      socialLabel: 'Links'
    },
    product: {
      eyebrow: 'Platform',
      title: 'Everything you need to work with a strategy in one place',
      subtitle:
        'Configure strategy parameters, validate them on historical data and launch automated trading directly from the Hedger interface.',
      cards: [
        {
          key: 'setup',
          title: 'Strategy setup',
          text: 'Set strategy parameters: timeframe, position size, leverage and order execution logic. All core settings are gathered in one interface.'
        },
        {
          key: 'backtest',
          title: 'Historical data validation',
          text: 'Before launch, you can check how the strategy would have performed on past market data and how selected parameters affect the result.'
        },
        {
          key: 'auto',
          title: 'Auto-trading launch',
          text: 'After configuration and validation, the strategy moves into live mode and starts trading automatically.'
        }
      ]
    },
    flow: {
      eyebrow: 'Launch',
      title: 'How to get started?',
      subtitle: 'Connect an exchange, configure a strategy and launch automated trading.',
      steps: [
        {
          index: '01',
          title: 'Connect an exchange',
          text: 'Add your exchange API key so the platform can work with your trading account.'
        },
        {
          index: '02',
          title: 'Configure the strategy',
          text: 'Set the strategy parameters and validate its result on historical data.'
        },
        {
          index: '03',
          title: 'Launch auto-trading',
          text: 'After configuration, the strategy starts in automatic mode and its performance can be monitored through the interface.'
        }
      ]
    },
    security: {
      eyebrow: 'Security',
      title: 'Control and access remain transparent.',
      text:
        'Funds remain on the exchange side, while connection is established through API permissions for trading actions. Strategy control and status monitoring are handled through Hedger.',
      bullets: [
        'The platform does not accept user deposits.',
        'API access is limited to trading actions.',
        'The guide walks the user through connection and first launch.'
      ],
      partnerLabel: 'Official partner',
      partnerText: 'Bybit'
    },
    resources: {
      eyebrow: 'Resources',
      title: 'Documentation and resources',
      items: [
        {
          key: 'guide',
          title: 'Guide',
          text: 'Step-by-step instructions for platform setup, exchange connection and strategy launch.'
        },
        {
          key: 'telegram',
          title: 'Telegram',
          text: 'The main Hedger channel for news, updates and communication with the community.'
        },
        {
          key: 'twitter',
          title: 'X / Twitter',
          text: 'Public updates about product development and new platform capabilities.'
        }
      ]
    },
    cta: {
      title: 'Configure the strategy and launch automated trading',
      text: 'Create a strategy, validate it on historical data and launch trading through the Hedger platform.',
      primary: 'Get started',
      secondary: 'Read guide'
    },
    footer: {
      copy: '© 2025 Hedger'
    }
  }
};
